module.exports = __webpack_public_path__ + "static/media/blob.3966919c.svg";